import { Box, Stack, Button } from '@mui/joy';
import { useTheme } from '@mui/material';
import { useMediaQuery } from '@mui/material';
import { useFieldArray } from 'react-hook-form';
import Add from '@mui/icons-material/Add';
import { GroupCard } from '@/features/recipes/components/GroupCard';
import { RemoveFormElementButton } from '@/components/RemoveFormElementButton';
import { MIN_INGREDIENT_GROUPS, MAX_INGREDIENT_GROUPS, MIN_INGREDIENTS, MAX_INGREDIENTS, newIngredientGroup, newIngredient } from '@/features/recipes/schema';
import { FormAmountUnit } from '@/features/units/components/FormAmountUnit';
import { IngredientAutocomplete } from '@/features/ingredients/components/IngredientAutocomplete';

export function IngredientsFormTab() {
  const { fields, append, remove } = useFieldArray({ name: 'ingredient_groups' });  

  return (<>
    <Stack spacing={2}>
      {fields.map((field, index) => (
        <IngredientGroupForm key={field.id} path={`ingredient_groups.${index}`} removable={fields.length > MIN_INGREDIENT_GROUPS} onRemove={() => remove(index)} />                
      ))}      
    </Stack>
    {fields.length < MAX_INGREDIENT_GROUPS && <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 1 }}>
      <Button startDecorator={<Add />} variant="plain" onClick={() => append(newIngredientGroup())}>Add Ingredient Group</Button>
    </Box>}
  </>);
}

function IngredientGroupForm({ path, removable, onRemove }) {  
  const { fields, append, remove } = useFieldArray({ name: `${path}.ingredients` });
  return (
    <GroupCard  placeholder="Group Name (e.g. Sauce, Main, etc.)" path={path} removable={removable} onRemove={onRemove}>
      <Stack spacing={2}>
        {fields.map((field, index) => (
          <IngredientForm key={field.id} path={`${path}.ingredients.${index}`} removable={fields.length > MIN_INGREDIENTS} onRemove={() => remove(index)} />
        ))}
        {fields.length < MAX_INGREDIENTS && <Box><Button startDecorator={<Add />} variant="outlined" onClick={() => append(newIngredient())}>Add Ingredient</Button></Box>}
      </Stack>
    </GroupCard>
  )
}

function IngredientForm({ path, removable, onRemove }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  
  return (
    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1} alignItems={{ xs: 'stretch', sm: 'center' }}>      
      <Stack direction="row" spacing={1} sx={{ width: { xs: '100%', sm: 'auto' }, flexGrow: 1 }} alignItems="center">
        <IngredientAutocomplete name={`${path}.name`} placeholder="Ingredient name" sx={{ flexGrow: 1 }} />        
        {isMobile && removable && <RemoveFormElementButton onClick={onRemove} />}
      </Stack>
      <Stack direction="row" spacing={1} sx={{ width: { xs: '100%', sm: 'auto' } }} alignItems="center">
        <FormAmountUnit path={path} sx={{ width: { xs: '100%', sm: '180px' } }} />
        {!isMobile && removable && <RemoveFormElementButton onClick={onRemove} />}
      </Stack>
    </Stack>
  )
}

